import { Container, Card, Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import "../styles/dualEducation.css";

export default function ThanksPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const formType = location.state?.formType || "Kapcsolat";

  const getThanksMessage = () => {
    switch (formType) {
      case "Duális képzés":
        return {
          title: "Köszönjük érdeklődését!",
          body: "Szakértő kollégánk 24 órán belül keresni fogja Önt a megadott elérhetőségeken, hogy egyeztessünk a képzési támogatás részleteiről.",
        };
      case "Nemzeti Bajnokok":
      case "Hátrányos helyzetű régiók (GINOP 1.2.4)":
      case "Vállalati Hitel":
        return {
          title: "Sikeres jelentkezés!",
          body: "Munkatársunk hamarosan felveszi Önnel a kapcsolatot az előminősítéshez szükséges adatok egyeztetése céljából.",
        };
      case "Számlaoptimalizálás":
        return {
          title: "Köszönjük megkeresését!",
          body: "Hamarosan jelentkezünk a bankszámla-optimalizálási javaslatunkkal és az átvilágítás további lépéseivel.",
        };
      default:
        return {
          title: "Köszönjük!",
          body: "Üzenetét megkaptuk, kollégánk hamarosan keresni fogja a megadott elérhetőségeken.",
        };
    }
  };

  const message = getThanksMessage();

  return (
    <Container className="hero d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
      <Card className="card px-4 py-5 text-center shadow-lg" style={{ maxWidth: "600px" }}>
        <div className="mb-4">
          <div
            className="rounded-circle bg-success d-inline-flex align-items-center justify-content-center"
            style={{ width: "80px", height: "80px" }}
          >
            <FontAwesomeIcon
              icon={faCheck}
              style={{ color: "white", fontSize: "40px" }}
            />
          </div>
        </div>
        <h1 className="h2 mb-3">{message.title}</h1>
        <p className="lead mb-4">{message.body}</p>
        <div className="cta justify-content-center">
          <Button
            className="btn btn-primary"
            onClick={() => navigate("/")}
          >
            Vissza a főoldalra
          </Button>
        </div>
      </Card>
    </Container>
  );
}



